var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEftpos128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EFTPOS-Pictogram_128x128px_Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2307692,18.8461538 C89.6114811,18.8461538 90.8614811,19.4057979 91.7663031,20.3106199 C92.6711252,21.215442 93.2307692,22.465442 93.2307692,23.8461538 L93.2307692,23.8461538 L93.2307692,108 C93.2307692,109.380712 92.6711252,110.630712 91.7663031,111.535534 C90.8614811,112.440356 89.6114811,113 88.2307692,113 L88.2307692,113 L31,113 C29.6192881,113 28.3692881,112.440356 27.4644661,111.535534 C26.5596441,110.630712 26,109.380712 26,108 L26,108 L26,23.8461538 C26,22.465442 26.5596441,21.215442 27.4644661,20.3106199 C28.3692881,19.4057979 29.6192881,18.8461538 31,18.8461538 L31,18.8461538 Z",
    id: "Rectangle",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 33.6923077,
    y: 26.5384615,
    width: 51.8461538,
    height: 51.8461538,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6923077,-10.082955 L62.120911,-3.05913462 C62.3916076,-2.70889267 62.5384615,-2.27874163 62.5384615,-1.83608364 L62.5384615,-1.83608364 L62.5384615,33.7379335 C62.5384615,34.1845462 62.3889757,34.6183086 62.1138256,34.9700974 L62.1138256,34.9700974 L56.6923077,41.9016951 L56.6923077,-10.082955 Z",
    id: "Path-9",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00",
    transform: "translate(59.615385, 15.923077) rotate(-90.000000) translate(-59.615385, -15.923077) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "card",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 55.7692308,
    y: 37.0769231,
    width: 47.3076923,
    height: 30,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5576923,37.0769231 L101.276923,37.0769231 C102.271036,37.0769231 103.076923,37.8828105 103.076923,38.8769231 L103.076923,65.2769231 C103.076923,66.2710356 102.271036,67.0769231 101.276923,67.0769231 L93.5576923,67.0769231 L93.5576923,67.0769231 L78.8461538,52.0769231 L93.5576923,37.0769231 Z",
    id: "focus",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    points: "65 42.8461538 68.4615385 46.3076923 65 49.7692308 61.5384615 46.3385603"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEftpos128);
export default __webpack_public_path__ + "static/media/pictogramEFTPOS128.5ef84298531f5fe1830fe456bcf69984.svg";
export { ForwardRef as ReactComponent };